import { Box, Stack, Typography } from '@mui/material';
import { Badge as SBadge, Icon } from '@shopify/polaris';
import { isInteger } from 'src/utils/type_check';

export const Badge = ({
  tone,
  backgroundColor,
  icon,
  iconColor,
  progress,
  children,
  color = '#000',
  style,
}) => {
  if (backgroundColor) {
    return (
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          backgroundColor: backgroundColor,
          borderRadius: 'var(--p-border-radius-200)',
          padding: '2px 8px',
          whiteSpace: 'nowrap',
          ...style,
        }}
      >
        <Stack
          direction={'row'}
          alignItems={'center'}
          spacing={0.3}
        >
          {icon !== undefined && (
            <Box sx={{ color: iconColor, display: 'flex', alignItems: 'center' }}>
              <Icon source={icon} />
            </Box>
          )}
          <Typography
            variant={isInteger(children) ? 'body_sm_medium' : 'body_md_medium'}
            sx={{ color: color }}
          >
            {children}
          </Typography>
        </Stack>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        '& .Polaris-Badge': { whiteSpace: 'nowrap' },
        '& .Polaris-Badge-Pip': {
          '--pc-pip-size': '16px',
          borderRadius: '50%',
        },
        '& .Polaris-Badge__PipContainer': {
          marginRight: '2.4px',
        },
      }}
    >
      <SBadge
        tone={tone}
        progress={progress}
        sx={{
          padding: '0 8px',
        }}
      >
        <Stack
          direction={'row'}
          alignItems={'center'}
          spacing={0.3}
        >
          {icon !== undefined && (
            <Box sx={{ color: iconColor, display: 'flex', alignItems: 'center' }}>
              <Icon source={icon} />
            </Box>
          )}

          <Typography
            variant={isInteger(children) ? 'body_sm_medium' : 'body_md_medium'}
            sx={{ transform: 'translateY(1px)' }}
          >
            {children}
          </Typography>
        </Stack>
      </SBadge>
    </Box>
  );
};
